export interface ICurrencies {
  currencySymbol: ICurrency;
  currencyCode: ICurrency;
}

export interface ICurrency {
  EUR: string;
  HUF: string;
  BGN: string;
  CZK: string;
  DKK: string;
  PLN: string;
  RON: string;
  SEK: string;
  GBP: string;
  NOK: string;
  ISK: string;
  CHF: string;
}

export const currencies: ICurrencies = {
  currencySymbol: {
    EUR: '€',
    HUF: 'Ft',
    BGN: 'лв',
    CZK: 'Kč',
    DKK: 'DKK',
    PLN: 'zł',
    RON: 'Lei',
    SEK: 'SEK',
    GBP: '£',
    NOK: 'NOK',
    ISK: 'ISK',
    CHF: 'CHF'
  },
  currencyCode: {
    EUR: 'EUR',
    HUF: 'HUF',
    BGN: 'BGN',
    CZK: 'CZK',
    DKK: 'DKK',
    PLN: 'PLN',
    RON: 'RON',
    SEK: 'SEK',
    GBP: 'GBP',
    NOK: 'NOK',
    ISK: 'ISK',
    CHF: 'CHF'
  }
};
